// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { TypographyProps } from "@insite/mobius/Typography";
import { fontConfig } from "@vanmeter/XDL/constants";
import { css } from "styled-components";

export const sharedAddressTextStyles: TypographyProps = {
    as: "p",
    weight: fontConfig.weight.regular,
    lineHeight: fontConfig.smallSingleLine.lineHeight,
    size: fontConfig.smallSingleLine.size,
    css: css`
        margin-bottom: 0;
    `,
};

addressInfoDisplayStyles.customerNameText = {
    ...sharedAddressTextStyles,
};

addressInfoDisplayStyles.attentionText = {
    ...sharedAddressTextStyles,
};

addressInfoDisplayStyles.companyNameText = {
    ...sharedAddressTextStyles,
};

addressInfoDisplayStyles.address1Text = {
    ...sharedAddressTextStyles,
};

addressInfoDisplayStyles.address2Text = {
    ...sharedAddressTextStyles,
};

addressInfoDisplayStyles.address3Text = {
    ...sharedAddressTextStyles,
};

addressInfoDisplayStyles.address4Text = {
    ...sharedAddressTextStyles,
};

addressInfoDisplayStyles.cityStatePostalCodeText = {
    ...sharedAddressTextStyles,
};

addressInfoDisplayStyles.countryText = {
    ...sharedAddressTextStyles,
};

addressInfoDisplayStyles.phoneText = {
    ...sharedAddressTextStyles,
    css: css`
        margin-top: 8px;
    `,
};

addressInfoDisplayStyles.emailText = {
    ...sharedAddressTextStyles,
    css: css`
        margin-top: 8px;
    `,
};

addressInfoDisplayStyles.faxText = {
    ...sharedAddressTextStyles,
};
